import { render, staticRenderFns } from "./PromotionCustomerGroup.vue?vue&type=template&id=22157d47&scoped=true&"
import script from "./PromotionCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./PromotionCustomerGroup.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCustomerGroup.vue?vue&type=style&index=0&id=22157d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22157d47",
  null
  
)

export default component.exports